type Article = {
  url: string;
  title: string;
  date: string;
  imageUrl: string;
};

export const generateArticlesMarkup = (articles: Article[]) => ({
  '@context': 'https://schema.org',
  '@type': 'ItemList',
  itemListElement: articles.map((article, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    item: {
      '@type': 'Article',
      url: article.url,
      name: article.title,
      datePublished: article.date,
      image: article.imageUrl,
    },
  })),
});
